const keyboardDatePickerFormService = {
  label: 'Fecha del Servicio'
};

export default keyboardDatePickerFormService;
